<template>
  <div class="aftersale-detail">
    <div class="title">
      <p>
        服务编号：{{ as_number }}(<span>{{ as_status }}</span
        >)
      </p>
    </div>
    <div class="table-title">商品信息</div>
    <el-table :data="aftersaleDetailTableData" border style="width: 100%">
      <el-table-column label="锐锢编码">
        <template slot-scope="scope">{{
          scope.row.detail[0].ruigu_code
        }}</template>
      </el-table-column>
      <el-table-column prop="self_code" label="三方商品编码"> </el-table-column>
      <el-table-column label="商品名">
        <template slot-scope="scope">{{ scope.row.detail[0].name }}</template>
      </el-table-column>
      <el-table-column label="规格">
        <template slot-scope="scope">{{ scope.row.detail[0].spec }}</template>
      </el-table-column>
      <el-table-column label="单位">
        <template slot-scope="scope">{{ scope.row.detail[0].unit }}</template>
      </el-table-column>
      <el-table-column prop="applied_num" label="申请数量"> </el-table-column>
      <el-table-column prop="received_num" label="收货数量">
        <template slot-scope="scope">
          <el-input
            v-model="scope.row.received_num"
            v-show="showReceiveAccept"
          ></el-input>
          <span v-show="!showReceiveAccept">{{ scope.row.received_num }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="accepted_num" label="确认数量">
        <template slot-scope="scope">
          <el-input
            v-model="scope.row.accepted_num"
            v-show="showEditAccept"
          ></el-input>
          <span v-show="!showEditAccept">{{ scope.row.accepted_num }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="returned_num" label="出库数量">
        <template slot-scope="scope">
          <el-input
            v-model="scope.row.returned_num"
            v-show="showReturnAccept"
          ></el-input>
          <span v-show="!showReturnAccept">{{ scope.row.returned_num }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="remark" label="异常原因" show-overflow-tooltip>
        <template slot-scope="scope">
          <el-input v-model="scope.row.remark" show-overflow-tooltip></el-input>
          <span class="remarkOverflow">{{ scope.row.remark }}</span>
        </template>
      </el-table-column>
      <!-- <el-table-column prop="send_amount" label="责任方">
      </el-table-column>
      <el-table-column prop="send_amount" label="赔付金额">
      </el-table-column> -->
    </el-table>
    <div v-if="showReturnAccept">
      <h4>物流信息</h4>
      <el-table :data="tsData" border style="width: 60%">
        <el-table-column prop="courier_code" label="物流承运商" width="145">
          <template slot="header" slot-scope="scope">
            <el-tooltip
              class="item"
              effect="light"
              content="按照选项[物流承运商]录入。若需录入的物流承运商在档案中没有，请提供给系统管理员维护。"
              placement="bottom"
            >
              <span class="el-icon-question">物流承运商</span>
            </el-tooltip>
          </template>
          <template slot-scope="scope">
            <el-select v-model="scope.row.courier_code" size="mini" filterable>
              <el-option
                v-for="item in tsList"
                :label="item.provider_name"
                :value="item.provider_code + ''"
                :key="item.provider_code"
              ></el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column prop="courier_number" label="物流运单号">
          <template slot="header" slot-scope="scope">
            <el-tooltip class="item" effect="light" placement="bottom">
              <div slot="content">
                <div>a.将单元格格式设置为文本；</div>
                <div>
                  b.若一个单据存在多个运单号，请用半角英文状态下的逗号“,”隔开。
                </div>
              </div>
              <span class="el-icon-question">物流运单号</span>
            </el-tooltip>
          </template>
          <template slot-scope="scope">
            <div>
              <el-input
                type="textarea"
                :autosize="{ minRows: 1 }"
                placeholder="多个运单号，请用英文逗号“,”隔开"
                v-model.trim="scope.row.courier_number"
              ></el-input>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="courier_mobile" label="物流联系电话">
          <template slot="header" slot-scope="scope">
            <el-tooltip class="item" effect="light" placement="bottom">
              <div slot="content">
                <div>将单元格格式设置为文本</div>
              </div>
              <span class="el-icon-question">物流联系电话</span>
            </el-tooltip>
          </template>
          <template slot-scope="scope">
            <div>
              <el-input
                style="width:100% !important;"
                placeholder="请填写物流联系电话"
                size="small"
                v-model="scope.row.courier_mobile"
              ></el-input>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <el-button type="primary" size="small" @click="saveDetail('open')"
      >保存</el-button
    >
    <el-dialog
      title="确认提示"
      :visible.sync="dialogVisible"
      center
      append-to-body
      width="500px"
    >
      <!-- 售后出库 -->
      <div style="text-align:center;" v-if="showReturnAccept">
        <h4>请确认信息</h4>
        <h4 style="color:red;">注：一旦保存，无法再修改。</h4>
      </div>
      <!-- 售后确认 维修 -->
      <div style="text-align:center;" v-if="showEditAccept && asType === '3'">
        <h4>请确认进入维修中</h4>
      </div>
      <!-- 售后确认 退货 -->
      <div style="text-align:center;" v-if="showEditAccept && asType === '1'">
        <div style="margin-bottom:20px;">
          <span style="display:inline-block;margin-right:15px;"
            >售后责任方</span
          >
          <el-radio-group v-model="freight_bearer">
            <el-radio :label="3">客户</el-radio>
            <el-radio :label="1">其他</el-radio>
          </el-radio-group>
        </div>
        <p style="color:red;">（确认信息，将作为退款处理的依据）</p>
      </div>
      <!-- 售后收货 -->
      <div style="text-align:center;" v-if="showReceiveAccept">
        <h4>请确认已收到商品</h4>
      </div>
      <div slot="footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="saveDetail('close')">确认</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import {
  getAsOrderStatus,
  getAsOrderType,
  getBigaftersaleDetail,
  acceptRefund,
  acceptRepair,
  receiptByShop,
  acceptExchange,
  bigshippedByShop
} from "@/models/aftersaleModel";
import { customExpressList } from "@/models/ts";
export default {
  data() {
    return {
      as_number: this.$route.query.number,
      as_status: "",
      aftersaleDetailTableData: [],
      showEditAccept: false, // 售后确认
      showReceiveAccept: false, // 售后收货
      showReturnAccept: false, // 售后出库
      asType: "", // 售后确认类型
      dialogVisible: false,
      form: {
        weight: "",
        bags: ""
      },
      freight_bearer: 3,
      rules: {
        weight: [
          // {type: 'number', message: '请输入总重量'}
        ],
        bags: [
          { required: true, message: "请输入打包数" },
          { type: "number", message: "打包数为数字" }
        ]
      },
      tsList: [], // 物流承运商列表
      tsData: [
        {
          courier_code: "",
          courier_number: "",
          courier_mobile: ""
        }
      ]
    };
  },
  async mounted() {
    try {
      let tsList = await customExpressList({});
      if (tsList.code === 200) {
        this.tsList = tsList.data.succeed.map(item => {
          return {
            provider_code: item.logistics_code,
            provider_name: item.logistics_name
          };
        });
        // this.tsList = tsList.data.succeed
      }
      // console.log('tsList', tsList.data.succeed)
    } catch (error) {}
    this.getAftersaleDetail(this.$route.query.number);
    if (this.$route.query.type === "return") {
      this.showReturnAccept = true;
    } else if (this.$route.query.type === "accept") {
      this.showEditAccept = true;
    } else if (this.$route.query.type === "receive") {
      this.showReceiveAccept = true;
    }
  },
  methods: {
    // 获取售后明细详情
    async getAftersaleDetail(number) {
      let params = {
        as_number: number,
        order_type: 1
      };
      this.statusList = await getAsOrderStatus();
      this.typeList = await getAsOrderType();
      let data = await getBigaftersaleDetail(params);
      if (this.showReceiveAccept) {
        data.received_num =
          data.received_num === "0" || data.received_num === 0
            ? ""
            : data.received_num;
      }
      if (this.showEditAccept) {
        data.accepted_num =
          data.accepted_num === "0" || data.accepted_num === 0
            ? ""
            : data.accepted_num;
      }
      if (this.showReturnAccept) {
        data.returned_num =
          data.returned_num === "0" || data.returned_num === 0
            ? ""
            : data.returned_num;
      }
      this.aftersaleDetailTableData = new Array(data);
      if (this.$route.query.type === "accept") {
        this.asType = this.aftersaleDetailTableData[0].as_type;
      }
      let matchStatusList = this.statusList.filter(
        item => item.value === data.as_status
      );
      if (matchStatusList.length !== 0) {
        this.as_status = matchStatusList[0].label;
      } else {
        this.as_status = data.as_status;
      }
      this.tsData[0].courier_code = data.courier_code || "";
      this.tsData[0].courier_number = data.courier_number || "";
      this.tsData[0].courier_mobile = data.courier_mobile || "";
    },
    getTsName(id) {
      let name = "";
      // console.log(this.tsList, 'this.tsList')
      this.tsList.forEach(item => {
        if (item.provider_code === id) {
          name = item.provider_name;
        }
      });
      return name;
    },
    // 保存
    async saveDetail(val) {
      let params = {
        as_number: this.$route.query.number,
        // ruigu_code: this.aftersaleDetailTableData[0].detail[0].ruigu_code,
        remark:
          this.aftersaleDetailTableData[0].remark == undefined
            ? ""
            : this.aftersaleDetailTableData[0].remark
      };
      // 售后确认接受退款(退货)
      if (
        this.$route.query.type === "accept" &&
        this.aftersaleDetailTableData[0].as_type === "1"
      ) {
        // 原入参
        /* params.accept_num = this.aftersaleDetailTableData[0].accepted_num
        params.freight_bearer = this.freight_bearer */
        // 新入参
        params.accepted_num = this.aftersaleDetailTableData[0].accepted_num;
        params.freight_bearer = this.freight_bearer;
        if (val === "close") {
          this.dialogVisible = false;
          await acceptRefund(params);
          this.$router.push("/bigAfterSale/manage");
        } else {
          if (
            this.aftersaleDetailTableData[0].accepted_num !==
              this.aftersaleDetailTableData[0].received_num ||
            this.aftersaleDetailTableData[0].accepted_num !==
              this.aftersaleDetailTableData[0].applied_num
          ) {
            //this.$message.error('确认数量与收货数量因若数量不等，请填写异常原因')
            this.$message.error(
              "温馨提示：数量请保持一致。若有问题，请联系锐锢客服修改数量。"
            );
            return false;
          }
          this.dialogVisible = true;
          return false;
        }
        return false;
      }
      // 售后确认接受维修(维修)
      if (
        this.$route.query.type === "accept" &&
        this.aftersaleDetailTableData[0].as_type === "3"
      ) {
        // 原入参
        //params.accept_num = this.aftersaleDetailTableData[0].accepted_num
        // 新入参
        params.accepted_num = this.aftersaleDetailTableData[0].accepted_num;
        if (val === "close") {
          this.dialogVisible = false;
          await acceptRepair(params);
          this.$router.push("/bigAfterSale/manage");
        } else {
          if (
            this.aftersaleDetailTableData[0].accepted_num !==
              this.aftersaleDetailTableData[0].received_num ||
            this.aftersaleDetailTableData[0].accepted_num !==
              this.aftersaleDetailTableData[0].applied_num
          ) {
            // this.$message.error('确认数量与收货数量因若数量不等，请填写异常原因')
            this.$message.error(
              "温馨提示：数量请保持一致。若有问题，请联系锐锢客服修改数量。"
            );
            return false;
          }
          this.dialogVisible = true;
          return false;
        }
        return false;
      }
      // 售后确认接受换货(换货)
      if (
        this.$route.query.type === "accept" &&
        this.aftersaleDetailTableData[0].as_type === "2"
      ) {
        // 原入参
        //params.accept_num = this.aftersaleDetailTableData[0].accepted_num
        // 新入参
        params.accepted_num = this.aftersaleDetailTableData[0].accepted_num;
        if (
          this.aftersaleDetailTableData[0].accepted_num ===
            this.aftersaleDetailTableData[0].received_num &&
          this.aftersaleDetailTableData[0].accepted_num ===
            this.aftersaleDetailTableData[0].applied_num
        ) {
          await acceptExchange(params);
          this.$router.push("/bigAfterSale/manage");
        } else {
          /*   else if (this.aftersaleDetailTableData[0].remark !== undefined && this.aftersaleDetailTableData[0].remark !== '' && this.aftersaleDetailTableData[0].remark.length >= 1) {
          await acceptExchange(params)
          this.$router.push('/bigAfterSale/manage')
        }  */
          //this.$message.error('确认数量与收货数量因若数量不等，请填写异常原因')
          this.$message.error(
            "温馨提示：数量请保持一致。若有问题，请联系锐锢客服修改数量。"
          );
          return false;
        }
        return false;
      }
      // 售后收货
      if (this.$route.query.type === "receive") {
        if (val === "close") {
          this.dialogVisible = false;
          // 原入参
          //params.real_num = this.aftersaleDetailTableData[0].received_num
          // 新入参
          params.received_num = this.aftersaleDetailTableData[0].received_num;
          await receiptByShop(params);
          this.$router.push("/bigAfterSale/manage");
        } else {
          if (
            this.aftersaleDetailTableData[0].received_num !==
            this.aftersaleDetailTableData[0].applied_num
          ) {
            //this.$message.error('收货数量必须等于申请数量。若数量不等，请与物流确认')
            this.$message.error(
              "收货数量必须等于申请数量。若有问题，请联系锐锢客服修改数量。"
            );
            return false;
          }
          this.dialogVisible = true;
          return false;
        }
        return false;
      }
      // 售后出库
      if (this.$route.query.type === "return") {
        // 工厂
        if (val === "close") {
          this.dialogVisible = false;
          // 原入参
          /* let obj = {
            // 工厂这两个参数传0
            total_weight: 0,
            box_num: 0,
            as_number: this.$route.query.number,
            ruigu_code: this.aftersaleDetailTableData[0].detail[0].ruigu_code,
            remark: this.aftersaleDetailTableData[0].remark,
            courier_number: this.tsData[0].courier_number,
            courier_mobile: this.tsData[0].courier_mobile,
            courier_name: this.tsData[0].courier_code ? this.getTsName(this.tsData[0].courier_code) : '',
            courier_code: this.tsData[0].courier_code,
            order_type: 1
          }
          obj.returned_num = this.aftersaleDetailTableData[0].returned_num */
          // 新入参
          let obj = {
            // 工厂这两个参数传0
            weight: 0,
            box_num: 0,
            as_number: this.$route.query.number,
            remark:
              this.aftersaleDetailTableData[0].remark == undefined
                ? ""
                : this.aftersaleDetailTableData[0].remark,
            courier_number: this.tsData[0].courier_number,
            courier_mobile: this.tsData[0].courier_mobile,
            courier_name: this.tsData[0].courier_code
              ? this.getTsName(this.tsData[0].courier_code)
              : "",
            courier_code: this.tsData[0].courier_code
          };
          obj.return_num = this.aftersaleDetailTableData[0].returned_num;
          await bigshippedByShop(obj);
          this.$router.push("/bigAfterSale/manage");
        } else {
          let tsStatus = this.checkTableData();
          if (
            this.aftersaleDetailTableData[0].returned_num !==
            this.aftersaleDetailTableData[0].accepted_num
          ) {
            this.$message.error("出库数量必须等于确认数量。");
            return false;
          } else if (tsStatus === -1) {
            this.$message.error("请填写快递单号");
            return false;
          } else if (tsStatus === -3) {
            this.$message.error("快递单号格式不正确");
            return false;
          } else if (tsStatus === -4) {
            this.$message.error("请选择物流承运商");
            return false;
          }
          this.dialogVisible = true;
        }
        return false;
      }
    },
    confirm() {
      this.saveDetail(true);
    },
    // 校验物流信息
    checkTableData() {
      let errorType = 1; // 错误类型 -1没有快递单号 -2快递单号与打包箱数不符  -3快递单号格式错误 -4承运商为空
      let reg = /^[A-Za-z0-9]+$/;
      this.tsData.forEach((item, index) => {
        let tsNumList = [];
        if (item.courier_number) {
          tsNumList = (item.courier_number + "").replace("，", ",").split(",");
        }
        if (!item.courier_code) {
          errorType = -4;
        } else if (!item.courier_number) {
          errorType = -1;
        } else {
          let every = tsNumList.every(item => {
            return reg.test(item);
          });
          if (!every) {
            errorType = -3;
          }
        }
      });
      return errorType;
    }
  }
};
</script>
<style lang="scss">
.aftersale-detail {
  padding: 0 0 0 15px;
  .title {
    p,
    span {
      font-weight: bold;
      font-size: 16px;
    }
    span {
      color: rgb(90, 125, 209);
    }
  }
  .table-title {
    height: 30px;
    width: 80px;
    margin-right: 1px;
    margin-top: 5px;
    border-radius: 8px 8px 0px 0px;
    background-color: rgb(239, 239, 239);
    line-height: 30px;
    text-align: center;
    font-weight: bold;
    font-size: 14px;
  }
  .el-table {
    .el-input .el-input__inner {
      height: 33px !important;
    }
    .el-input__inner {
      padding: 0;
      text-align: center;
    }
    .el-input {
      width: 120px !important;
    }
    .remarkOverflow {
      color: #fff;
    }
  }
  .el-button {
    position: fixed;
    bottom: 20px;
    left: 50%;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/bigAftersale/aftersale-detail.vue